import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import HeroSection from "@/components/sections/HeroSection";
import ProblemStatement from "@/components/sections/ProblemStatement";
import TechnologyExplorer from "@/components/sections/TechnologyExplorer";
import BiosafetyInfra from "@/components/sections/BiosafetyInfra";
import ScientificClaims from "@/components/sections/ScientificClaims";
import ScientificValidation from "@/components/sections/ScientificValidation";
import Applications from "@/components/sections/Applications";
import Partners from "@/components/sections/Partners";
import StrategicPositioning from "@/components/sections/StrategicPositioning";
import MetricsTraction from "@/components/sections/MetricsTraction";
import Team from "@/components/sections/Team";
import InvestmentSection from "@/components/sections/InvestmentSection";
import NewsFeed from "@/components/sections/NewsFeed";
import ContactSection from "@/components/sections/ContactSection";

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Navbar />
      <HeroSection />
      <ProblemStatement />
      <TechnologyExplorer />
      <BiosafetyInfra />
      <ScientificClaims />
      <ScientificValidation />
      <Applications />
      <Partners />
      <StrategicPositioning />
      <MetricsTraction />
      <Team />
      <InvestmentSection />
      <NewsFeed />
      <ContactSection />
      <Footer />
    </div>
  );
}
